import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { initAuth } from './lib/user'

initAuth()

createRoot(document.getElementById('root')!).render(<StrictMode><App /></StrictMode>)
